import React, {Component} from 'react'
import TokenStorage from '../../utils/tokenStorage';

import {Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';

import queryString from 'qs';

import * as actionCreators from '../../store/actions/login';
class Impersonate extends Component {
    componentDidMount() {
        const me = this;
      
        const search = queryString.parse(this.props.location.search);

        const isImpersonation = !!search.accountNumber;
        console.log('ISIMPERSONATION', isImpersonation);
        if (this.props.match.params.token) {
           
            TokenStorage.backup();
            // const authDataString = TokenStorage.get(); const authDataObj =
            // JSON.parse(authDataString);
            
            // Auth
            //     .impersonateByRefreshToken(this.props.match.params.token, 'testuser')
                me.props.impersonate(this.props.match.params.token, search.accountNumber) //TODO: need to check why this is hardcoded?
                .then(() => {
                    me
                        .props
                        .restoreUserLogin(isImpersonation);
                }, (failureData) => {
                    
                    console.log(failureData);
                });

        }

    }
    render() {
        return (
            <Redirect to="/"></Redirect>
        )
    }
}
export default connect(state => state.login, dispatch => bindActionCreators(actionCreators, dispatch))(Impersonate);
